export const typography = {
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    // h1: { fontSize: "2.5rem", fontWeight: 700 },
    // h2: { fontSize: "2rem", fontWeight: 600 },
    // body1: { fontSize: "1rem" },
    // button: { textTransform: "none" },
  };
  